/**
 * Self-service authenticator 2FA — BFF /me/2fa*.
 */

import { tenantApiFetch, tenantDashboardPath } from "@/lib/tenantApi";

export class PersonalTotpClient {
  async getStatus() {
    return tenantApiFetch(tenantDashboardPath("/me/2fa"), { method: "GET", timeoutMs: 12000 });
  }

  async start() {
    return tenantApiFetch(tenantDashboardPath("/me/2fa/start"), { method: "POST" });
  }

  /**
   * @param {{ enroll_session: string, code: string }} payload
   */
  async confirm(payload) {
    return tenantApiFetch(tenantDashboardPath("/me/2fa/confirm"), {
      method: "POST",
      body: JSON.stringify({
        enroll_session: payload.enroll_session,
        code: payload.code,
      }),
    });
  }

  /**
   * @param {{ code: string }} payload
   */
  async disable(payload) {
    return tenantApiFetch(tenantDashboardPath("/me/2fa"), {
      method: "DELETE",
      body: JSON.stringify({ code: payload.code }),
    });
  }
}
